import React from 'react';
import RadioQuestionType from './types/radio';
import CheckboxQuestionType from './types/checkbox';
import TextQuestionType from './types/text';
import SelectQuestionType from './types/select';
import CountrySelectQuestionType from './types/countrySelect';
import TextAreaQuestionType from './types/textarea';
import NumberQuestionType from './types/number';
import DateQuestionType from './types/date';
import AktorQuestionType from './types/aktor';
import AktorListQuestionType from './types/aktor/list';
import CrsQuestionType from './types/crs/index';
import CrsV2QuestionType from './types/crs-v2/index';
import FatcaV2QuestionType from './types/fatca-v2/index';
import RrQuestionType from './types/rr/index';
import InternasjonaleOverforingerQuestionType from './types/int-overforinger/index';
import Textlist from './types/textlist';

import {
    SPORSMALSTYPE_CRS_CAP,
    SPORSMALSTYPE_CRS_V2_CAP,
    SPORSMALSTYPE_FATCA_V2_CAP,
    SPORSMALSTYPE_LAND_CAP,
    SPORSMALSTYPE_RADIO_CAP,
    SPORSMALSTYPE_RADIO_CLASSIC_CAP,
    SPORSMALSTYPE_CHECKBOX_CAP,
    SPORSMALSTYPE_TEXT_CAP,
    SPORSMALSTYPE_TEXT_AREA_CAP,
    SPORSMALSTYPE_DATE_CAP,
    SPORSMALSTYPE_SELECT_CAP,
    SPORSMALSTYPE_NUMBER_CAP,
    SPORSMALSTYPE_AMOUNT_CAP,
    SPORSMALSTYPE_TEXT_LIST_CAP,
    SPORSMALSTYPE_RR_CAP,
    SPORSMALSTYPE_INTERNASJONALE_OVERFORINGER_CAP,
    SPORSMALSTYPE_AKTOR_CAP,
    SPORSMALSTYPE_AKTOR_LIST_CAP,
    SPORSMALSTYPE_DISPONENT_LIST_CAP,
} from '../constants/general';
import DisponentListQuestionType from './types/disponent/list';

// questionState er for å lure komponenten til å rendre riktig, men brukes ikke i komponenten
const mapper = (question, questionState, hasError, validateIfNotSet, appNamespace, isSubQuestion = false) => {
    switch (question.type) {
        case SPORSMALSTYPE_RADIO_CAP:
        case SPORSMALSTYPE_RADIO_CLASSIC_CAP:
            return (
                <RadioQuestionType
                    question={question}
                    questionState={questionState}
                    hasError={hasError}
                    validateIfNotSet={validateIfNotSet}
                />
            );

        case SPORSMALSTYPE_AKTOR_CAP:
            return <AktorQuestionType question={question} />;

        case SPORSMALSTYPE_AKTOR_LIST_CAP:
            return <AktorListQuestionType question={question} />;

        case SPORSMALSTYPE_DISPONENT_LIST_CAP:
            return <DisponentListQuestionType question={question} appNamespace={appNamespace} />;

        case SPORSMALSTYPE_CRS_CAP:
            return (
                <CrsQuestionType
                    question={question}
                    questionState={questionState}
                    hasError={hasError}
                    validateIfNotSet={validateIfNotSet}
                />
            );

        case SPORSMALSTYPE_CRS_V2_CAP:
            return (
                <CrsV2QuestionType
                    question={question}
                    questionState={questionState}
                    hasError={hasError}
                    validateIfNotSet={validateIfNotSet}
                />
            );
        case SPORSMALSTYPE_FATCA_V2_CAP:
            return (
                <FatcaV2QuestionType
                    question={question}
                    questionState={questionState}
                    hasError={hasError}
                    validateIfNotSet={validateIfNotSet}
                />
            );
        case SPORSMALSTYPE_RR_CAP:
            return (
                <RrQuestionType
                    question={question}
                    questionState={questionState}
                    hasError={hasError}
                    validateIfNotSet={validateIfNotSet}
                    appNamespace={appNamespace}
                />
            );

        case SPORSMALSTYPE_TEXT_CAP:
            return (
                <TextQuestionType
                    question={question}
                    questionState={questionState}
                    hasError={hasError}
                    isSubQuestion={isSubQuestion}
                    validateIfNotSet={validateIfNotSet}
                />
            );

        case SPORSMALSTYPE_TEXT_AREA_CAP:
            return (
                <TextAreaQuestionType
                    question={question}
                    questionState={questionState}
                    hasError={hasError}
                    isSubQuestion={isSubQuestion}
                    validateIfNotSet={validateIfNotSet}
                />
            );

        case SPORSMALSTYPE_DATE_CAP:
            return (
                <DateQuestionType
                    question={question}
                    questionState={questionState}
                    hasError={hasError}
                    validateIfNotSet={validateIfNotSet}
                />
            );

        case SPORSMALSTYPE_CHECKBOX_CAP:
            return (
                <CheckboxQuestionType
                    question={question}
                    questionState={questionState}
                    hasError={hasError}
                    validateIfNotSet={validateIfNotSet}
                />
            );

        case SPORSMALSTYPE_LAND_CAP:
            return (
                <CountrySelectQuestionType
                    question={question}
                    questionState={questionState}
                    hasError={hasError}
                    isSubQuestion={isSubQuestion}
                    validateIfNotSet={validateIfNotSet}
                />
            );
        case SPORSMALSTYPE_SELECT_CAP:
            return (
                <SelectQuestionType
                    question={question}
                    questionState={questionState}
                    hasError={hasError}
                    validateIfNotSet={validateIfNotSet}
                />
            );

        case SPORSMALSTYPE_NUMBER_CAP:
        case SPORSMALSTYPE_AMOUNT_CAP:
            return (
                <NumberQuestionType
                    question={question}
                    questionState={questionState}
                    hasError={hasError}
                    validateIfNotSet={validateIfNotSet}
                />
            );

        case SPORSMALSTYPE_INTERNASJONALE_OVERFORINGER_CAP:
            return (
                <InternasjonaleOverforingerQuestionType
                    question={question}
                    questionState={questionState}
                    hasError={hasError}
                    validateIfNotSet={validateIfNotSet}
                />
            );

        case SPORSMALSTYPE_TEXT_LIST_CAP:
            return (
                <Textlist
                    question={question}
                    questionState={questionState}
                    hasError={hasError}
                    validateIfNotSet={validateIfNotSet}
                />
            );

        default:
            return (
                <div>
                    <em> -- Mangler mapping -- </em>
                </div>
            );
    }
};

export default mapper;
